import React, { useContext } from 'react';
import usePageClassName from '../hooks/usePageClassName';
import useTranslation from '../hooks/useTranslation';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../toolkit/WithTitle';

type Props = {};

const Error401Page: React.FC<Props> = () => {
  const { t } = useTranslation();
  usePageClassName('error-page');
  const { pages } = useContext(ConfigContext);
  const title = t('pageTitles.error401') || t('pageTitles.error');
  const Page = pages.error401?.component || pages.error.component;
  return (
    <WithTitle title={title}>
      <Page />
    </WithTitle>
  );
};
Error401Page.displayName = 'Error401Page';

export default Error401Page;
